import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ImageUploaderApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	uploadImage(formData: FormData): Observable<{ id: string; url: string }> {
		return this.httpClient.post<{ id: string; url: string }>(`${this.apiUrl}/multimedia/file/`, formData);
	}
}
